import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=5f4a38d3"
import script from "./Resellers.vue?vue&type=script&lang=ts"
export * from "./Resellers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports